import React, { useEffect, useState } from "react";
import { Field, FormikProvider, Form, useFormik, ErrorMessage } from "formik";
import Menubar from "../Menubar";
import ShowAlert from "../alert";
import autoTable from "jspdf-autotable";
import { Container, Button, Col , Row } from "reactstrap";
import { CiFloppyDisk } from "react-icons/ci";
import SwaranandhraService from "../../Services/SwaranandhraService";
export default function NewUnitsAddService() {
    const [searchText, setSearchText] = useState("");
const[unitslist,setUnitslist]=useState();
    

  let username = localStorage.getItem("username");


  
  const fetchUnitsList = () => {
    SwaranandhraService.getUnitslist().then((res) => {
      if (res.data) {
        const list = res.data.map((item) => ({
          id: item.id,
          value: item.value,
        }));
        setUnitslist(list);
      }
    });
  };
  
  useEffect(() => {
    fetchUnitsList();
  }, []);

  const formik = useFormik({
    initialValues: {
        unit:"",
        unit_description:"",
   
    },

  })


  const allowAlphaNumeric = (e) => {
    const input = e.target;
    const value = input.value;
    const key = e.key;


    const regex = /^[a-zA-Z0-9\s!@#$%^&*(),.?":{}|<>]*$/;


    if (input.selectionStart === 0 && input.selectionEnd === value.length) {
        if (!regex.test(key)) {
            e.preventDefault();
        }
    } else {
        if (!regex.test(value + key)) {
            e.preventDefault();
        }
    }
};

const Addunit=()=>{
    
    let params={
        "userId":username,
    "unitName":formik.values.unit,
    "unitDescription":formik.values.unit_description
    }
    SwaranandhraService.addNewUnit(params).then((res1) => {
        if (res1.data && res1.data.SCODE === "01") {
           ShowAlert(res1.data.SDESC,"success")
            fetchUnitsList();
          } 
        else{
            ShowAlert(res1.data.SDESC,"error")
        }
        
      });
      formik.setFieldValue("unit","");
      formik.setFieldValue("unit_description","");

}
  const filteredData = searchText.length > 0 ? unitslist?.filter((item) => {
    return (
      item &&
      Object.keys(item).some((key) => {
        const value = item[key];
        return (
          value !== null &&
          value
            .toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
        );
      })
    );
  }) : unitslist;

  return (
    <>
      <Menubar />
      <Container fluid className='map-header'>
        <div className='sa-title'>
          <h2>Unit <span>Master</span></h2>
        </div>
      </Container>
     
      <Container fluid>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Row>
              <Col xs={12} sm={12} lg={12} md={12} xl={6} xxl={6}>
                <div className='indicators main-tb'>
                  <h5>Add New Unit </h5>
                  <div className='indicators-info'>
                  <FormikProvider value={formik} >
                            <Form onSubmit={formik.handleSubmit}>
                                <Row className="mt-2 ">
                                    
                                    <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} >
                                        <label className="mb-1 fw-bold" htmlFor="unit" >Unit</label> <span style={{ color: "red" }}> *</span></Col>
                                        <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} >
                                        <Field id="unit" type="text" name="unit" className="form-control" onKeyPress={(e) => allowAlphaNumeric(e)} onChange={(e) => { formik.handleChange(e); }} />
                                        <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="unit" /> </span>
                                    </Col>
                                    </Row>
                                    <Row className="mt-2 ">
                                    <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} >
                                        <label className="mb-1 fw-bold" htmlFor="unit_description" > Unit Description</label> <span style={{ color: "red" }}> *</span></Col>
                                        <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} >
                                        <Field id="unit_description" as="textarea" name="unit_description" className="form-control" onKeyPress={(e) => allowAlphaNumeric(e)} onChange={(e) => { formik.handleChange(e); }} />
                                        <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="unit_description" /> </span>
                                    </Col>
                                    
                                </Row>
                            </Form>
                        </FormikProvider>
                        <div className='mt-5'>
                    <Button className='map-btn ' type="button" onClick={Addunit}>Save<CiFloppyDisk className='ms-3' /></Button>{' '}
                  </div>
                  </div>
                </div>
               
 
              </Col>
 

              <Col xs={12} sm={12} lg={12} md={12} xl={6} xxl={6} className="agr-secto">
              
              <div className='indicators1 main-tb'>
                <h5>Units</h5>
                
                <Form inline className='search-bar'>
      <Row>
        <Col>
        <input type="text" className="form-control border-0" placeholder="Search" onChange={(event) => setSearchText(event.target.value)} />
        </Col>
      </Row>
    </Form>
    <div className='indicators-info1' id="my-table">
    {filteredData?.map((detail, i) => (
        <div key={i} className="activity-box d-flex mt-2">
        <div className="number-box-main d-flex align-items-center">
        <div className="number-box " style={{marginRight:"30px"}}>
                          <p>{i+1}</p>
                        </div>
                        
 <div className="ha d-flex" style={{marginRight:"30px"}}>
    <div className="unit">
      <p>Unit</p>
    </div>
    <div className="ha-box text-center">
      <p>{detail.value}</p>
    </div>
  </div>
 
  </div>
  
  </div>
))}

</div>
              </div>
            
            </Col>

            </Row>
          </Form>
        </FormikProvider>
      </Container>
     
    </>
  );
}